import { jsx as _jsx } from "react/jsx-runtime";
import { NumericField } from '@/core/ui';
import { forwardRef } from 'react';
/**
 * Numeric field that converts any numeric value to it's max value that specified with {@link maxValue} param.
 *
 * Such a numeric field, for example, is required for stockman that handles reception on Stock for faster receipt.
 * @param maxValue
 * @returns
 */
const MaxLimitNumericField = forwardRef(({ maxValue, onChange, ...props }, ref) => {
    const handleChange = (value) => {
        const updatedValue = value && maxValue !== undefined && value > maxValue ? maxValue : value;
        onChange(updatedValue);
    };
    return _jsx(NumericField, { autoComplete: "off", ...props, ref: ref, onChange: handleChange });
});
export { MaxLimitNumericField };
